import React, { useState } from 'react';
import { Card, Statistic } from 'antd';
import { fetchData } from '../../service/dataServices';

function NumberCard({ title, urlPath }) {
  const [data, setData] = useState();

  const response = fetchData('/api/dashboard/' + urlPath, data => setData(data));

  return (
    <Card loading={response.isLoading}>
      <Statistic
        title={title}
        value={data}
        valueStyle={{ color: '#4695b0' }}
      />
    </Card>
  );
}

export default NumberCard;
